<template>
  <div class="baned_new relativeItem">
    <img src="../../assets/xinyu/bg.png" class="bg" />
    <img src="../../assets/xinyu/weigao.png" class="weigui absoluteItem" @click="gobaned()" />
    <img src="../../assets/xinyu/ming.png" class="ming absoluteItem" />
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    gobaned() {
      this.$router.push({ path: "/baned" });
    }
  }
};
</script>

<style scoped>
.baned_new {
  width: 100%;
}
.bg {
  width: 100%;
}
.weigui {
  right: 0;
  top: 3%;
  width: 30px;
  height: 85px;
}
.ming {
  width: 90%;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
}
</style>